import React, { useState } from 'react'
import { GeneralSnackbar } from '../Snackbar/generalSnackbar'
import { ShareBtnCon } from './styles'
import { copyLinkFunc } from '../../Utils'
import { SnackbarData } from '../../Api'
import { IosShareIcon } from '../LazyComponents/lazyIcons'

type ShareButtonParams = {
  link: string
  size: 'lg' | 'sm'
  border: boolean
  theme?: 'light' | 'dark'
  label?: string
  circular?: boolean
  background?: string
}

export const CopyIcon: React.FC<React.PropsWithChildren<ShareButtonParams>> = ({
  label,
  link,
  size,
  border = false,
  theme = 'light',
  circular = false,
  background,
}) => {
  const [showSnackbar, setShowSnackbar] = useState<boolean>(false)
  const [snackbar, setSnackbar] = useState<SnackbarData>({ color: 'green', text: '' })

  const handleClick = async () => {
    if (showSnackbar) return Promise.resolve()

    const successfulCopy = await copyLinkFunc(link, [])
    if (successfulCopy) {
      setSnackbar({ color: 'green', text: 'Copied the link 🙌' })
      setShowSnackbar(true)
    } else {
      setSnackbar({ color: 'red', text: 'Failed to copy the link' })
      setShowSnackbar(true)
    }
  }

  const handleSnackbarClose = () => {
    setShowSnackbar(false)
  }

  return (
    <>
      <ShareBtnCon
        onClick={handleClick}
        size={size}
        border={border}
        sTheme={theme}
        circular={circular}
        background={background}
      >
        <IosShareIcon className="icon" />
        {label && <p className="label">{label}</p>}
      </ShareBtnCon>
      {showSnackbar && (
        <GeneralSnackbar
          text={snackbar.text}
          color={snackbar.color}
          show={showSnackbar}
          onClose={handleSnackbarClose}
        />
      )}
    </>
  )
}
